// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"HP","selections":"IP","pillsDesktopSearchMenu":"JP"};